const addLeadingZero = number => (number < 10 ? '0' + number.toString() : number)

export default addLeadingZero
